import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { FMS_READ_SCOPE, fmsReadBasePath } from '#/api/fmsMgmt/fmsReadScope';
import { voucherListQueryToApiParams } from './listQueryToApiParams';

/** GET `/fms/vouchers`（`.read`）或 `/fms/vouchers/self`（`.self`） */
export async function fetchVoucherList(listQuery, { scope = FMS_READ_SCOPE.ALL } = {}) {
  const { data: raw } = await request.get(fmsReadBasePath('vouchers', scope), {
    params: voucherListQueryToApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
